import {Inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject} from 'rxjs';
import {first, take} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {Krk} from '../interface/krk';
import {CountedAndPaginated} from '../interface/response/counted-and-paginated';
import {ListResponse} from '../interface/response/list-response';
import {FilterService} from './filter.service';
import {DOCUMENT} from '@angular/common';
import {Document as DocumentInterface} from '../interface/document';
import {Uuid} from "../interface/response/uuid";

@Injectable({
  providedIn: 'root'
})
export class KrkService {
  private readonly krkListSubject: ReplaySubject<CountedAndPaginated<Krk>> = new ReplaySubject<CountedAndPaginated<Krk>>(1);
  private readonly krkNotCountedListSubject: ReplaySubject<ListResponse<Krk>> = new ReplaySubject<ListResponse<Krk>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  getKrkListSubject(): ReplaySubject<CountedAndPaginated<Krk>> {
    return this.krkListSubject;
  }

  sendForm(formData: object, krkId: string): Observable<any> {
    if (!krkId) {
      return this.httpClient.post(`/rest/crm/krk`, formData)
        .pipe(take(1));
    } else {
      return this.httpClient.put(`/rest/crm/krk/${krkId}`, formData)
        .pipe(take(1));
    }
  }

  get(krkId: string): Observable<Krk> {
    return this.httpClient.get(`/rest/crm/krk/${krkId}`)
      .pipe(first()) as Observable<Krk>;
  }

  deleteKrk(krkId: string): Observable<any> {
    return this.httpClient.delete(`/rest/crm/krk/${krkId}`)
      .pipe(first());
  }

  public loadList(page: number, pageSize: number, filters: object): void {
    this.httpClient.get(`/rest/crm/krk?page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Krk>) => {
        this.krkListSubject.next(result);
      });
  }

  public loadNotCountedList(page: number, pageSize: number, filters: object, observable?: ReplaySubject<ListResponse<Krk>>): void {
    this.httpClient
      .get(`/rest/crm/krk?disableCount=1&page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(take(1))
      .subscribe((result: ListResponse<Krk>) => {
        if (observable) {
          observable.next(result);
        } else {
          this.krkNotCountedListSubject.next(result);
        }
      });
  }

  getKrkDocuments(krkId: string): Observable<ListResponse<DocumentInterface>> {
    return this.httpClient.get(`/rest/crm/krk/${krkId}/document`)
      .pipe(first()) as Observable<ListResponse<DocumentInterface>>;
  }

  downloadReport(filters: object): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/krk/method/report?` + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }

  updateKrkActiveFeeController(uuid: string, formData: {activeFee: boolean}): Observable<any> {
    return this.httpClient.put(`/rest/crm/krk/${uuid}/updateKrkActiveFee`, formData)
      .pipe(first());
  }

}
